import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  ProductReview,
  ProductReviewData,
} from '@features/product/interfaces/product-review.interface';
import { ProductReviewService } from '@features/product/services/product-review.service';
import {
  faSortDown,
  faSortUp,
  faStar,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fc-product-detail-review',
  templateUrl: './product-detail-review.component.html',
  styleUrls: ['./product-detail-review.component.css'],
})
export class ProductDetailReviewComponent implements OnInit {
  productDefaultImg: string = 'assets/images/product/default-product.png';
  faStar = faStar;
  faSortDown = faSortDown;
  faSortUp = faSortUp;

  @Input() slug!: string;
  @ViewChild('reviewList') reviewList?: ElementRef;

  averageRating = 0;
  totalReviews: number = 0;
  reviewImages: string[] = [];
  reviews: ProductReview[] = [];
  groupReviewRating: any = [];

  reviewImagesSwiperConfig = {
    slidesPerView: 'auto',
    spaceBetween: 5,
    loop: false,
    freeMode: true,
    navigation: true,
  };
  userDefaultPhoto?: any;
  shopDefaultLogo?: any;

  constructor(private productReviewService: ProductReviewService) {}

  ngOnChanges() {
    this.productReviewService
      .getProductReviews(this.slug, 5, 1)
      .subscribe((data: ProductReviewData) => {
        this.averageRating = data.review_summary.average_review
          ? data.review_summary.average_review
          : 0;
        this.totalReviews = data.total_items;
        this.reviewImages = data.review_images;
        this.reviews = data.reviews;
        this.groupReviewRating = this.productReviewService.groupReviewRating(
          data.review_summary
        );
      });
  }

  ngOnInit(): void {}
  // utilities
  roundAvgRating(rate: number) {
    return Math.round(rate);
  } // for rating star color
  userErrorImg() {
    this.userDefaultPhoto = 'assets/images/default-user.png';
  }
  shopErrorImg() {
    this.shopDefaultLogo = 'assets/images/shop/default-shop-logo.webp';
  }

  loadProductReviews(currentPage: number) {
    this.productReviewService
      .getProductReviews(this.slug, 5, currentPage)
      .subscribe((data: ProductReviewData) => {
        this.reviews = data.reviews;
      });
  }

  pageChange(page: number) {
    this.loadProductReviews(page);
    this.onScrollToReviewListTop();
  }

  onScrollToReviewListTop() {
    let headerOffset = 200;
    let offsetPosition =
      this.reviewList?.nativeElement.offsetTop - headerOffset;
    window.scrollTo({ top: offsetPosition });
  }

  showReply(review: ProductReview) {
    review.showReply = !review.showReply;
  }
}
